module.exports.game = {
  vi: {
    title: 'Avalon: The Resistance | Ván chơi',
    description: 'Phòng chơi The Resistance: Avalon trực tuyến.',
    keywords: ['Ván chơi'],
  },
  pt: {
    title: 'Avalon: The Resistance | Jogo',
    description: "Salas para jogos online em 'Avalon: The Resistance'",
    keywords: ['Jogo'],
  },
  en: {
    title: 'Avalon: The Resistance | Game',
    description: "Rooms for online games in 'Avalon: The Resistance'",
    keywords: ['Game'],
  },
  ru: {
    title: 'Авалон: Сопротивление | Игра',
    description: "Комната для игры в 'Авалон: Сопротивление'",
    keywords: ['Игра'],
  },
  'zh-TW': {
    title: '阿瓦隆：反抗勢力 | 遊戲',
    description: '『阿瓦隆：反抗勢力』的在線遊戲房間',
    keywords: ['遊戲'],
  },
  'zh-CN': {
    title: '阿瓦隆：反抗组织 | 游戏',
    description: '《阿瓦隆：反抗组织》的在线游戏房间',
    keywords: ['游戏'],
  },
  es: {
    title: 'Avalon: La Resistencia | Juego',
    description: "Salas para juegos en línea en 'Avalon: La Resistencia'",
    keywords: ['Juego'],
  },
};
